import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import * as React from 'react';
import * as Redux from 'react-redux';
import * as CONST from '../../../../constants/FieldsConst';
import SelectAutocomplete from '../../../../widgets/SelectAutocomplete';
import { allEntNivelesAcademicosAction } from '../EntNivelesAcademicosAction';

const SelectFieldEntNivelesAcademicosComponent = ({
  onChange,
  id,
  data,
  value,
  required,
  isEmpty = false,
  isAll = true,
  selects = [],
  isAutoComplete,
}) => {
  const dispatch = Redux.useDispatch();

  const entidadesStore = Redux.useSelector((state) => state.entidades);
  const entNivelesAcademicosStore = Redux.useSelector(
    (state) => state.entNivelesAcademicos,
  );

  const [items, setItems] = React.useState([]);

  React.useEffect(() => {
    const fetchData = async () => {
      if (!data && entNivelesAcademicosStore.all.length === 0) {
        await allEntNivelesAcademicosAction(dispatch, {
          idEntidad: entidadesStore.activo.id,
        });
        setItems(entNivelesAcademicosStore.all);
      }
    };
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const _handlerSelects = () => {
    let items = [];
    if (selects.length > 0) {
      entNivelesAcademicosStore.all.forEach((se) => {
        const existSeletc = selects.some((item) => item.id === se.id);
        if (!existSeletc) items.push(se);
      });
      setItems(items);
    } else {
      if (data) {
        setItems(data);
      } else {
        setItems(
          entNivelesAcademicosStore.all.sort(
            (a, b) =>
              Number(a.nivelAcademico.numero) - Number(b.nivelAcademico.numero),
          ),
        );
      }
    }
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  React.useEffect(async () => _handlerSelects(), [selects]);

  const select = (
    <FormControl fullWidth size="small" required={required}>
      <InputLabel id={`label_${id}`}>{CONST.nivelAcademico.label}</InputLabel>
      <Select
        id={id}
        value={value}
        labelId={`label_${id}`}
        label={CONST.nivelAcademico.label}
        onChange={(e) => onChange(e.target.value)}
      >
        {isEmpty ||
          (isAll && (
            <MenuItem key={`${id}-000-item`} value={null}>
              {isAll ? ' TODOS' : 'NINGUNO'}
            </MenuItem>
          ))}
        {items.map((el, index) => {
          return (
            <MenuItem key={`item_${id}_${index}`} value={el.id}>
              {el.nivelAcademico.abrev} -{el.nivelAcademico.nombre}
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  );

  const autoComplete = (
    <SelectAutocomplete
      id={id}
      opt={items}
      type={CONST.nivelAcademico.name}
      onChange={(event, newValue) => onChange(newValue?.id)}
      l={CONST.nivelAcademico.label}
    />
  );

  return isAutoComplete ? autoComplete : select;
};

export default SelectFieldEntNivelesAcademicosComponent;
